<template>
    <fieldset class="forms__fieldset">
        <legend hidden>{{ lang('reservations::slots.title') }}</legend>

        <Field
            v-model="modelValue.reservable_id"
            :field="fields.reservable_id"
            dusk="form-reservable_id"
            :options="props.reservables"
            required
        />
        <Field v-model="modelValue.name" :field="fields.name" dusk="form-name" required>
            <template v-if="calculatedName" #help>
                <p class="text-xs opacity-50">
                    {{ lang('reservations::slots.fields.calculated_name') }}
                </p>
            </template>
        </Field>

        <Field v-model="modelValue.time_slot_from" :field="fields.time_slot_from" dusk="form-time_slot_from" required />
        <Field v-model="modelValue.time_slot_to" :field="fields.time_slot_to" dusk="form-time_slot_to" required />
    </fieldset>
</template>

<script setup lang="ts">
import { toRef, watch } from 'vue';
import { Reservable } from '@src/Reservations/Pages/types';
import { dateTimeHumanReadableWithoutYearFromISO } from '@src/Common/Helpers/dates';

const modelValue = defineModel({
    type: Object as () => Reservable,
});

interface Props {
    fields: Record<string, unknown>;
    reservables: Reservable[];
    calculatedName?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    calculatedName: false,
});

const calculatedName = toRef(props, 'calculatedName');

watch(
    modelValue,
    (value) => {
        if (calculatedName.value) {
            modelValue.value.name = dateTimeHumanReadableWithoutYearFromISO(value.time_slot_from);
        }
    },
    { deep: true },
);
</script>
